<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 600px; background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <h1 class="display-2 text-white">API Keys</h1>
                        <p class="text-white mt-0 mb-5">Your API keys are ready for use. These keys are public and can be used on your website's frontend. Take a look at the paysly docs for more info on how to accept payments with paysly:</p>
                        <a target="_blank" href="https://docs.paysly.io/overview.html" class="btn btn-white">api docs</a>
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col order-xl-1">
                    <card shadow type="secondary" style="margin-bottom:20%">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-4">
                                    <h3 class="mb-0">Stripe Connections</h3>
                                </div>
                                <div class="col-8 text-right">
                                  <!-- <a style="color:white; margin: 3px;" @click="auth(false)" class="btn btn-sm btn-light">Connect Additional Test Account</a> -->
                                  <a style="color:white; margin: 3px;" @click="auth(true)" class="btn btn-sm btn-success">Connect Additional Account</a>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <span v-for="item in user.userData" :key="item.createdAt.seconds">
                                  <h6 class="heading-title text-muted mb-4">{{ item.account.settings.dashboard.display_name }}</h6>
                                  <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                          <base-input alternative=""
                                            label="Public Key"
                                            input-classes="form-control-alternative"
                                            v-model="item.stripePublishableKey"
                                          />
                                        </div>
                                        <div class="col-lg-6">
                                          <base-switch
                                            label="Live / Test"
                                            input-classes="form-control-alternative"
                                            :value="!item.stripePublishableKey.startsWith('pk_test')"
                                          />
                                        </div>
                                    </div>
                                  </div>
                                  <hr class="my-4" />
                                </span>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import firebase from '../firebase';


  export default {
    name: 'user-profile',
    computed: {
      ...mapState([
        'user'
      ]),
      ...mapGetters([
        'userData'
      ])
    },
    mounted() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      if (code) {
        const stripeAuthenticate = firebase.functions.httpsCallable('stripeAuthenticate');
        const live = process.env.VUE_APP_live === 'true';
        stripeAuthenticate({code, live});
        params.delete('code');
      }
    },
    methods: {
      auth(live) {
        window.location.href = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.VUE_APP_STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${process.env.VUE_APP_STRIPE_SETUP_URL}&state=${live}`;
      }
    },
  };
</script>
<style></style>
